<template>
  <div
    class="s-filial-item"
    :class="{
      selected: selected,
      's-select-value': isSelectValue,
      's-list-item': isListItem,
      's-use-callcenter': item.useCallCenter,
      's-is-not-connected': isNotConnected,
      's-is-connected': isConnected,
      's-is-disabled': isDisabled,
    }"
  >
    <div class="s-filial-item__icon">
      <icon-deactivated-filial v-if="isDisabled" />
      <icon-franchise-filial v-else-if="item.franchise" />
      <icon-own-filial v-else />
    </div>
    <div class="s-filial-item__content">
      <div class="s-filial-item__address">
        {{ firstNameLine }}
      </div>
      <div v-if="!item.isCallCenter" class="s-filial-item__city">
        {{ lastNameLine }}
      </div>
    </div>
  </div>
</template>

<script>
  import IconOwnFilial from '@/components/icons/filial/IconOwnFilial'
  import IconFranchiseFilial from '@/components/icons/filial/IconFranchiseFilial'
  import IconDeactivatedFilial from '@/components/icons/filial/IconDeactivatedFilial.vue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'GlobalFilialSelectItem',
    components: { IconDeactivatedFilial, IconFranchiseFilial, IconOwnFilial },
    props: {
      item: Object,
      selected: Boolean, // выбранный в списке
      isSelectValue: Boolean,
      isListItem: Boolean,
    },
    computed: {
      ...mapGetters({
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
      }),
      firstNameLine () {
        if (this.item?.isCallCenter) {
          return this.item.name
        }
        return this.item.address || this.item.name
      },
      lastNameLine () {
        if (this.item?.isCallCenter) {
          return this.item.address
        }
        return this.item.city
      },
      isNotConnected () {
        return (
          this.indicateFilialConnectionStatus && this.item?.isConnected === false
        )
      },
      isConnected () {
        return (
          this.indicateFilialConnectionStatus && this.item?.isConnected === true
        )
      },
      isDisabled () {
        return !this.item.status
      },
    },
  }
</script>

<style lang="less" scoped>
.s-filial-item {
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
  overflow: hidden;

  /*&:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: red;
  }*/

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #c4cdd9;
    svg {
      color: #c4cdd9;
      transition: 0.3s ease;
    }
  }

  &__content {
    line-height: 1.3;
    color: #000;
  }

  &__address {
    white-space: nowrap;
    //margin-bottom: 2px;
    text-overflow: ellipsis;
    padding-right: 5px;
    overflow: hidden;
  }

  &__city {
    color: #c4cdd9;
    white-space: nowrap;
  }

  &:hover,
  &.selected {
    .s-filial-item__icon {
      svg {
        //color: #FF9100;
      }
    }
  }

  &.s-list-item {
    width: 100%;
    padding: 0 16px;
    margin-left: -16px;
    margin-right: -16px;
  }

  &.s-select-value {
    .s-filial-item__icon {
      svg {
        //color: #FF9100;
      }
    }
  }

  &.s-use-callcenter {
    .s-filial-item__icon {
      color: #ff9100;
      svg {
        color: #ff9100;
      }
    }
    /*.s-filial-item__address {
      font-weight: bold;
    }*/
  }

  // Цвет значка - состояние филиала: оранжевый - подключён к FACT,
  // красный - не подключён, серый - выключен
  &.s-is-not-connected:not(.s-is-disabled) {
    .s-filial-item__icon {
      color: @color-error;
      svg {
        color: @color-error;
      }
    }
    .s-filial-item__address {
      color: @color-btn-dark-grey;
    }
  }

  &.s-is-connected:not(.s-is-disabled) {
    .s-filial-item__address {
      font-weight: bold;
    }
    .s-filial-item__icon {
      color: @color-primary;
      svg {
        color: @color-primary;
      }
    }
  }

  &.s-is-disabled {
    .s-filial-item__address {
      color: #9aa0ac;
    }
    // серый и у филиала с колл-центром: выключенный не подсвечиваем
    .s-filial-item__icon {
      color: #c4cdd9;
      svg {
        color: #c4cdd9;
      }
    }
  }
}
</style>
